import React from 'react';
import AccountMetricsPanel from '@src/pages/SelfServeDashboard/AccountMetricsPanel';
import ConversionFunnel from '@src/pages/SelfServeDashboard/ConversionFunnel';
import Timeline from '@src/pages/SelfServeDashboard/Timeline';
import { useCustomerOnboardingTimeline } from '@src/pages/SelfServeDashboard/hooks/useCustomerOnboardingTimeline';
import { Spin } from 'antd';
import { RedirectToHomePage } from '@src/routers/FeatureCheck';
import useUser from '@src/BaseApp/hooks/useUser';
import { isDryRunCustomer } from '@src/pages/SelfServeDashboard/utils';
import { SelfServeDashboardWrapper } from './styled';

const SelfServeDashboard = () => {
  const { data: user, loading } = useUser();

  const isDryRun = isDryRunCustomer(user?.customerId);

  const { data: customerOnboardingTimelineData, isLoading } = useCustomerOnboardingTimeline();

  if (loading) {
    return <Spin />;
  }

  if (!isDryRun) {
    return <RedirectToHomePage />;
  }

  return (
    <Spin spinning={isLoading}>
      <SelfServeDashboardWrapper>
        <AccountMetricsPanel data={customerOnboardingTimelineData} />
        <Timeline data={customerOnboardingTimelineData} user={user} />
        <ConversionFunnel data={customerOnboardingTimelineData} />
      </SelfServeDashboardWrapper>
    </Spin>
  );
};

export default SelfServeDashboard;
